import { render, staticRenderFns } from "./SearchPucharseOrders.vue?vue&type=template&id=473b173b&"
import script from "./SearchPucharseOrders.vue?vue&type=script&lang=js&"
export * from "./SearchPucharseOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports